import React, { useState } from 'react';

import PropTypes from 'prop-types';

import styles from '../../../../../shared/styles/_form.module.scss';

const Field = ({ attributes, sectionId, setThemeSettings, updateWebsiteSection }) => {
  const { value: initialVal, id, label, type } = attributes;

  const [fieldVal, setFieldVal] = useState(initialVal);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setThemeSettings((prevState) => {
      const updatedThemeSettings = {
        ...prevState,
        sections: {
          ...prevState.sections,
          [sectionId]: {
            ...prevState.sections[sectionId],
            [name]: value,
          },
        },
      };

      updateWebsiteSection({
        sectionId,
        sectionSettings: updatedThemeSettings.sections[sectionId],
      });

      return updatedThemeSettings;
    });

    setFieldVal(value);
  };

  return (
    <div className={styles.field}>
      <label htmlFor={id}>{label}</label>

      <input id={id} name={id} onChange={handleChange} type={type} value={fieldVal} />
    </div>
  );
};

Field.propTypes = {
  attributes: PropTypes.shape({
    value: PropTypes.string,
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  }).isRequired,
  sectionId: PropTypes.string.isRequired,
  setThemeSettings: PropTypes.func.isRequired,
  themeSettings: PropTypes.shape({
    sections: PropTypes.shape({}).isRequired,
  }).isRequired,
  updateWebsiteSection: PropTypes.func.isRequired,
};

export default Field;
